import clsx from 'clsx';
import { CloseIcon, SearchIcon } from '../icons';
import { IconButton } from '../icon-button/IconButton';
import textFieldStyles from '../textfield/TextField.module.css';
import styles from './SearchField.module.css';

export function SearchField({
  value,
  onChange,
  onClear,
  placeholder = '',
  ariaLabel = 'Search',
  className = '',
  inputClassName = '',
}) {
  const canClear = String(value ?? '').trim().length > 0;

  return (
    <div className={clsx(textFieldStyles.field, styles.field, className)} aria-label={ariaLabel}>
      <SearchIcon className={clsx(styles.searchIcon)} />
      <input
        className={clsx(styles.input, inputClassName)}
        type="text"
        value={value ?? ''}
        onChange={(event) => onChange?.(event.target.value)}
        aria-label={ariaLabel}
        placeholder={placeholder}
      />
      {canClear ? (
        <IconButton
          ariaLabel="Clear search"
          className={clsx(styles.clearButton)}
          onClick={onClear}
          size="sm"
        >
          <CloseIcon className={clsx(styles.clearIcon)} />
        </IconButton>
      ) : null}
    </div>
  );
}
